/* tslint:disable */
import { ICompleteData, IQuoteAction, IQuoteActions, IQuoteState } from './models';
import * as api from '../../data/api/api';
import * as uuid from 'uuid/v4';
import { ICustomer, IPolicyApplication, IProduct, IQuotes, IPremium } from '../../data/api/models';
import { IStore } from '../../redux/IStore';
import { change, getFormValues } from 'redux-form';
import { cloneDeep, forEach } from 'lodash';
import { recalculateScore } from '../healix/reducer';
import { IBrandingState } from '../branding/models';

// @ts-ignore
const initialState: IQuoteState = {
  isCalculating: false,
  isSignposting: false,
  initialised: false,
  application: {
    id: '',
    productCode: null,
    tripType: null,
    groupType: null,
    startDate: '',
    endDate: '',
    destinations: [],
    region: '',
    quotationDeclaration: false,
    travellers: [
      {
        id: uuid(),
        title: '',
        firstName: '',
        lastName: '',
        dob: '',
        phone: '',
        email: '',
        address: {
          line1: '',
          line2: '',
          town: '',
          county: '',
          postcode: '',
        },
        type: 'adult',
        screening: null,
        screeningSessionId: '',
      },
    ],
    medicalDeclaration: [],
    schemeId: '',
    quoteReference: '',
    payOnAccount: false,
    steps: ['tripDetails'],
    generateDocuments: false,
    emailSend: false,
    claims: undefined,
    criminal: undefined,
    campaignCode: null,
    calculateAllSchemes: false,
    whereDidYouHearAboutUs: '',
    options: null,
    purchaseChannel: null,
    activities: [],
    ageVehicle: '',
    vehicleReg: '',
    membershipNumber: '',
    membershipScheme: '',
    camcMembership: false,
    maydayBreakdown: false,
    addressSelected: false
  },
  destinations: [],
  customer: {},
  quotes: {},
  policy: null,
  complete: null,
  isRetrievingQuote: false,
  errorMessage: null,
  voucherCodeStatus: '',
  voucherCodeMessage: '',
  campaignCode: null,
  quoteError: false,
  aggError: false,
  redirectLink: '',
  aggName: '',
  signpost: null,
  autoRenewalStatus: '',
  autoRenewalStatusReason: '',
};

const INIT = 'b2c/quote/INIT';
const SET_STEPS = 'b2c/quote/SET_STEPS';
const SET_APPLICATION = 'b2c/quote/SET_APPLICATION';
const SET_CUSTOMER = 'b2c/quote/SET_CUSTOMER';
const SET_DESTINATIONS = 'b2c/quote/SET_DESTINATIONS';
const SET_IS_CALCULATING = 'b2c/quote/SET_IS_CALCULATING';
const SET_IS_SIGNPOSTING = 'b2c/quote/SET_IS_SIGNPOSTING';
const SET_QUOTE_STEPS = 'b2c/quote/SET_QUOTE_STEPS';
const SET_QUOTES = 'b2c/quote/SET_QUOTES';
const SET_SIGNPOST = 'b2c/quote/SET_SIGNPOST';
const SET_POLICY = 'b2c/quote/SET_POLICY';
const SET_BROKER_ID = 'b2c/quote/SET_BROKER_ID';
const SET_CAMPAIGN_CODE = 'b2c/quote/SET_CAMPAIGN_CODE';
const COMPLETE = 'b2c/quote/COMPLETE';
const RESET = 'b2c/quote/RESET';
const RETRIEVE_QUOTE = 'b2c/quote/RETRIEVE_QUOTE';
const UPDATE_APPLICATION = 'b2c/quote/UPDATE_APPLICATION';
const HAS_TERMINAL_CONDITION = 'b2c/quote/b2c/quote/HAS_TERMINAL_CONDITION';
const SET_ERROR_MESSAGE = 'b2c/quote/b2c/quote/SET_ERROR_MESSAGE';
const VOUCHER_CODE_SUCCESS = 'b2c/quote/VOUCHER_CODE_SUCCESS';
const VOUCHER_CODE_ERROR = 'b2c/quote/VOUCHER_CODE_ERROR';
const VOUCHER_CODE_RESET = 'b2c/quote/VOUCHER_CODE_RESET';
const DISPATCH_CAMPAIGN_CODE = 'b2c/quote/DISPATCH_CAMPAIGN_CODE';
const CLEAR_ADDITIONAL_COVER_OPTIONS = 'b2c/quote/CLEAR_ADDITIONAL_COVER_OPTIONS';
const COMPLETE_DOCUMENTS = 'b2c/quote/COMPLETE_DOCUMENTS';
const HAS_ERROR_SET_PASSWORD = 'b2c/quote/HAS_ERROR_RESET_PASSWORD';
const CLEAR_ERRORS = 'b2c/quote/CLEAR_ERRORS';
const LOADING = 'b2c/quote/LOADING';
const QUOTE_ERROR = 'b2c/quote/QUOTE_ERROR';
const AGG_ERROR = 'b2c/quote/AGG_ERROR';
const RETRIEVE_ACTIVITIES = 'b2c/quote/SET_ACTIVITIES';
const SET_AUTO_RENEWAL_STATUS = 'b2c/quote/SET_AUTO_RENEWAL_STATUS';
const SET_AUTO_RENEWAL_STATUS_REASON = 'b2c/quote/SET_AUTO_RENEWAL_STATUS_REASON';

export function reducer(state: IQuoteState = initialState, action: IQuoteAction): IQuoteState {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        initialised: true,
        application: {
          ...action.payload,
        },
      };
    case SET_DESTINATIONS:
      return {
        ...state,
        destinations: action.payload.destinations,
      };
    case SET_APPLICATION:
      return {
        ...state,
        application: action.payload.application,
        customer: action.payload.application.customer,
      };
    case SET_CUSTOMER:
      return {
        ...state,
        customer: action.payload.customer,
      };
    case SET_IS_CALCULATING:
      return {
        ...state,
        isCalculating: action.payload.isCalculating,
      };
    case SET_IS_SIGNPOSTING:
      return {
        ...state,
        isSignposting: action.payload.isSignposting,
      };
    case SET_QUOTES:
      return {
        ...state,
        quotes: action.payload.quotes,
      };
    case SET_SIGNPOST:
      return {
        ...state,
        signpost: action.payload.signpost,
      };
    case SET_AUTO_RENEWAL_STATUS:
      return {
        ...state,
        autoRenewalStatus: action.payload.autoRenewalStatus,
      };
    case SET_AUTO_RENEWAL_STATUS_REASON:
      return {
        ...state,
        autoRenewalStatusReason: action.payload.autoRenewalStatusReason,
      };
    case SET_POLICY:
      return {
        ...state,
        policy: action.payload.policy,
      };
    case SET_BROKER_ID:
      return {
        ...state,
        application: {
          ...state.application,
          brokerId: action.payload,
        },
      };
    case CLEAR_ADDITIONAL_COVER_OPTIONS:
      return {
        ...state,
        application: {
          ...state.application,
          options: null,
        },
      };
    case SET_QUOTE_STEPS:
      return {
        ...state,
        application: {
          ...state.application,
          steps: action.payload,
        },
      };
    case SET_CAMPAIGN_CODE:
      return {
        ...state,
        campaignCode: action.payload.campaignCode,
      };
    case DISPATCH_CAMPAIGN_CODE:
      return {
        ...state,
        application: {
          ...state.application,
          campaignCode: action.payload,
        },
      };
    case COMPLETE:
      return {
        ...state,
        complete: action.payload,
        errorMessage: null,
      };
    case COMPLETE_DOCUMENTS:
      return {
        ...state,
        complete: {
          ...state.complete,
          documents: action.payload,
        },
      };
    case SET_STEPS:
      return {
        ...state,
        application: {
          ...state.application,
          steps: action.payload.steps,
        },
      };
    case UPDATE_APPLICATION:
      return {
        ...state,
        application: {
          ...state.application,
          ...action.payload,
        },
      };
    case HAS_TERMINAL_CONDITION:
      return {
        ...state,
        application: {
          ...state.application,
          steps: ['tripDetails', 'travellersDetails', 'medicalDeclaration'],
        },
      };
    case RETRIEVE_QUOTE:
      return {
        ...state,
        isRetrievingQuote: true,
        application: action.payload.quote,
      };
    case VOUCHER_CODE_SUCCESS:
      return {
        ...state,
        voucherCodeStatus: 'success',
        voucherCodeMessage: 'APPLIED',
      };
    case VOUCHER_CODE_ERROR:
      return {
        ...state,
        application: {
          ...state.application,
          campaignCode: '',
        },
        voucherCodeStatus: 'error',
        voucherCodeMessage: 'NOT FOUND',
      };
    case VOUCHER_CODE_RESET:
      return {
        ...state,
        voucherCodeStatus: '',
        voucherCodeMessage: '',
      };
    case SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload.message,
      };
    case HAS_ERROR_SET_PASSWORD:
      return {
        ...state,
        setPassword: false,
        errors: {
          ...state.errors,
          setPassword: {
            hasError: true,
            errors: action.payload,
          },
        },
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        setPassword: true,
        errors: {
          ...state.errors,
          setPassword: {
            hasError: false,
            errors: [],
          },
        },
      };
    case LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case QUOTE_ERROR:
      return {
        ...state,
        quoteError: true,
        errorMessage: action.payload,
      };
    case AGG_ERROR:
      return {
        ...state,
        aggError: true,
        redirectLink: action.payload.link,
        aggName: action.payload.name,
      };
    case RESET:
      return {
        ...cloneDeep(initialState),
        destinations: {...state.destinations},
      };
    case RETRIEVE_ACTIVITIES:
      return {
        ...state,
        application: {
          ...state.application,
          activities: action.payload.activities,
        },
      };
    default:
      return state;
  }
}

const clearErrors = () => (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};

const setPassword = (password: string, passwordConfirmation: string) => (dispatch) => {
  dispatch(change('quote', 'password', password));
  dispatch(change('quote', 'passwordConfirmation', passwordConfirmation));
};

const submitForm = (
    formValues,
    calculatePremium = false,
    fromReduxFormValues = false,
    patch = false,
    generateDocuments = false,
) => (dispatch, getState) => {
  dispatch({ type: LOADING, payload: true });

  const state: IStore = getState();
  const { branding, quote } = state;
  const baseApplication: IPolicyApplication = quote.application;

  // @ts-ignore
  const reduxFormValues = (getFormValues('quote')(state) || {}) as any;

  const valuesBase: any = fromReduxFormValues
      ? reduxFormValues
      : (formValues ? formValues : baseApplication);

  if (generateDocuments) {
    valuesBase.generateDocuments = generateDocuments;
  }

  const formOptions = reduxFormValues.options || {};

  const existingOptions =
      (baseApplication &&
          baseApplication.metadata &&
          baseApplication.metadata.options) ||
      (baseApplication && (baseApplication as any).options) ||
      {};

  const mergedOptions = {
    ...existingOptions,
    ...formOptions,
  };

  const payload: IPolicyApplication = {
    ...baseApplication,
    ...valuesBase,
    options: mergedOptions,
    metadata: {
      ...(baseApplication.metadata || {}),
      ...(valuesBase.metadata || {}),
      options: mergedOptions,
    },
  };

  let brokerId = null;
  let hasAppId = false;

  if (quote.application.id) {
    hasAppId = true;
  }

  if (branding.trackingLink && branding.trackingLink.status === 'active') {
    brokerId = branding.trackingLink.id;
  }

  const channelId = branding.channel.id;
  const productCode = branding.channel.products[0].productCode;

  const promise = hasAppId
      ? api.updatePolicyApplication(payload, { calculatePremium, patch })
      : api.createPolicyApplication(payload, channelId, brokerId, productCode);

  return promise
      .then((application: IPolicyApplication) => {
        // 8) Ensure application in state also carries merged options
        const updatedApplication: IPolicyApplication = {
          ...application,
          options: mergedOptions,
          metadata: {
            ...(application.metadata || {}),
            options: mergedOptions,
          },
        };

        // Keep redux-form 'quote' in sync for "Back" navigation
        forEach(updatedApplication, (value, key) => {
          dispatch(change('quote', key, value));
        });

        const calculateAfterCreateApplication = !hasAppId && calculatePremium;

        dispatch(setApplication(updatedApplication));
        if (updatedApplication.quotes) {
          dispatch(setQuotes(updatedApplication.quotes));
        }
        dispatch({ type: LOADING, payload: false });

        if (calculateAfterCreateApplication) {
          dispatch(calculate(updatedApplication));
        }
      })
      .catch((error) => {
        dispatch({ type: HAS_ERROR_SET_PASSWORD, payload: error.response.data.errors });
        dispatch({ type: QUOTE_ERROR, payload: error.response.data.errors[0].detail });
        dispatch({ type: LOADING, payload: false });
        return error;
      });
};



const saveQuote = (calculate = false) => (dispatch, getState) => {
  const state: IStore = getState();
  const { branding, quote } = state;
  const baseApplication: IPolicyApplication = quote.application;

  // @ts-ignore
  const formValuesAll = (getFormValues('quote')(state) || {}) as any;

  const formOptions = formValuesAll.options || {};

  const formMetadataOptions =
      formValuesAll.metadata && formValuesAll.metadata.options
          ? formValuesAll.metadata.options
          : {};

  const mergedOptions = {
    ...formMetadataOptions,
    ...formOptions,
  };

  const payload: IPolicyApplication = {
    ...baseApplication,
    ...formValuesAll,
    options: mergedOptions,
    metadata: {
      ...(baseApplication.metadata || {}),
      ...(formValuesAll.metadata || {}),
      options: mergedOptions,
    },
  };

  const promise = api.saveQuote(payload, branding.channel.id, { calculate });

  return promise.then((application: IPolicyApplication) => {
    const updatedApplication: IPolicyApplication = {
      ...application,
      options: mergedOptions,
      metadata: {
        ...(application.metadata || {}),
        options: mergedOptions,
      },
    };

    forEach(updatedApplication, (value, key) =>
        dispatch(change('quote', key, value)),
    );

    dispatch(setApplication(updatedApplication));
  });
};



const retrieveQuote = (quote) => (dispatch) => {
  return dispatch({ type: RETRIEVE_QUOTE, payload: { quote } });
};

const checkVoucherCode = (campaignCode) => (dispatch, getState) => {
  const state: IStore = getState();
  const { branding } = state;

  return api.checkCampaignCode(campaignCode, branding.channel.id)
    .then((response) => {
      if (response.data) {
        dispatch({ type: VOUCHER_CODE_SUCCESS });
      }
    })
    .catch(() => {
      dispatch({ type: VOUCHER_CODE_ERROR });
      setTimeout((() => {
        dispatch({ type: VOUCHER_CODE_RESET });
      }), 3000);
    });
};

const dispatchVoucherCode = (campaignCode) => (dispatch) => {
  dispatch({ type: DISPATCH_CAMPAIGN_CODE, payload: campaignCode });
  dispatch(checkVoucherCode(campaignCode));
};

// @ts-ignore
const loadCustomer = () => (dispatch) => {
  return api.getCustomer()
    .then((customer: ICustomer) => {
      dispatch(setCustomer(customer));
    });
};

import { getFormValues } from 'redux-form';

// ...

import { getFormValues } from 'redux-form';

import { getFormValues } from 'redux-form';

const calculate = (formValues = null, fromReduxFormValues = false) => (dispatch, getState) => {
  dispatch(setIsCalculating(true));

  const state: IStore = getState();
  const { quote } = state;
  const baseApplication: IPolicyApplication = quote.application;

  // @ts-ignore
  const formValuesAll = fromReduxFormValues
      ? (getFormValues('quote')(state) || {})
      : (formValues || {});

  const formOptions = (formValuesAll as any).options || {};

  const existingOptions =
      (baseApplication &&
          baseApplication.metadata &&
          baseApplication.metadata.options) ||
      {};

  const mergedOptions = {
    ...existingOptions,
    ...formOptions,
  };

  const payload: IPolicyApplication = {
    ...baseApplication,
    ...(formValuesAll as any),
    options: mergedOptions,
    metadata: {
      ...(baseApplication && baseApplication.metadata ? baseApplication.metadata : {}),
      options: mergedOptions,
    },
  };

  return api
      .updatePolicyApplication(payload, { calculatePremium: true })
      .then((application: IPolicyApplication) => {
        const stateAfter = getState();
        const { quote: currentQuote } = stateAfter;

        const mergedQuotes = {
          ...(currentQuote && currentQuote.quotes ? currentQuote.quotes : {}),
          ...(application && application.quotes ? application.quotes : {}),
        };

        const updatedApplication: IPolicyApplication = {
          ...application,
          quotes: mergedQuotes,
          options: mergedOptions,
          metadata: {
            ...(application && application.metadata ? application.metadata : {}),
            options: mergedOptions,
          },
        };
        dispatch(setQuotes(mergedQuotes));
        dispatch(setCustomer(application.customer));
        dispatch(setIsCalculating(false));
        dispatch(setApplication(updatedApplication));
      })
      .catch((error) => {
        dispatch({
          type: QUOTE_ERROR,
          payload: error.response.data.errors[0].detail || 'Quote error',
        });
        dispatch(setIsCalculating(false));
      });
};


// @ts-ignore
const processSignpost = (premiums: IPremium[], policyApplicationId: string, tripType: string) => (dispatch) => {
  const filteredPremiums = tripType === 'annual' ? premiums.filter((premium) =>
      premium.schemeType === 'annual') : premiums;

  const sortedPremiums: {
    nonMedicalPremiums: IPremium[];
    medicalPremiums: IPremium[];
    medicalDeclines: IPremium[];
    screeningErrors: IPremium[];
    nonMedicalDeclines: IPremium[];
  } = {
    nonMedicalPremiums: [],
    medicalPremiums: [],
    medicalDeclines: [],
    screeningErrors: [],
    nonMedicalDeclines: [],
  };

  const processedPremiums = filteredPremiums.reduce((carry, premium: IPremium) => {
    const hasErrors = premium.errors && premium.errors.length;
    const hasDeclines = premium.declines && premium.declines.length;

    if (
        !hasDeclines &&
        !hasErrors &&
        !premium.isSignposted
    ) {
      carry.nonMedicalPremiums.push(premium);
      return carry;
    }

    if (
        !hasDeclines &&
        !hasErrors &&
        premium.isSignposted
    ) {
      carry.medicalPremiums.push(premium);
      return carry;
    }

    if (hasDeclines || hasErrors) {
      const errors = premium.errors || [];
      const declines = premium.declines || [];

      const hasAnnualExclusion = !!errors.find((error) =>
          error.includes('Medical Condition has annual exclusion'),
      );
      if (tripType !== 'annual' && hasAnnualExclusion) {
        carry.medicalDeclines.push(premium);
        return carry;
      }

      const hasScreeningError = errors.find(
          (error) =>
              error.includes('Medical Condition has winter sports exclusion') ||
              error.includes('Medical Condition has annual exclusion'),
      );
      if (hasScreeningError) {
        carry.screeningErrors.push(premium);
        return carry;
      }
      const hasMedicalError = errors.reduce((errorCarry, error) => {
        if (
            error.includes('Exceeds maximum medical score') ||
            error.includes('Maximum premium of') ||
            error.includes('Medical Declaration Question \'is-terminal\' is not covered')
        ) {
          return true;
        }
        return errorCarry;
      }, false);
      const hasMedicalDecline = declines.reduce((declineCarry, decline) => {
        if (decline.isMedical) {
          return true;
        }
        return declineCarry;
      }, false);
      if (hasMedicalError || hasMedicalDecline) {
        carry.medicalDeclines.push(premium);
        return carry;
      }
      carry.nonMedicalDeclines.push(premium);
    }
    return carry;
  }, sortedPremiums);

  if (
      !!processedPremiums.medicalPremiums.length &&
      !processedPremiums.nonMedicalPremiums.length
  ) {
    return api.getSignpost(policyApplicationId, 'medical_premiums_b2c')
        .then((result) => {
          dispatch(setSignpost(result.content));
          return 'medical_premiums_b2c';
        });
  }

  if (processedPremiums.screeningErrors.length === filteredPremiums.length) {

    return api.getSignpost(policyApplicationId, 'screening_errors_b2c')
        .then((result) => {
          dispatch(setSignpost(result.content));
          return 'screening_errors_b2c';

        });
  }

  if (processedPremiums.medicalDeclines.length === filteredPremiums.length) {
    return api.getSignpost(policyApplicationId, 'medical_declines_b2c')
        .then((result) => {
          dispatch(setSignpost(result.content));
          return 'medical_declines_b2c';
        });
  }
  dispatch(setSignpost(null));
  return false;
};

const setBrokerId = (brokerId) => ({ type: SET_BROKER_ID, payload: brokerId });
export const setDestinations = (destinations) => ({ type: SET_DESTINATIONS, payload: { destinations } });
const setApplication = (application: IPolicyApplication) => ({ type: SET_APPLICATION, payload: { application } });
const setCustomer = (customer: ICustomer) => ({ type: SET_CUSTOMER, payload: { customer } });
const setQuotes = (quotes: IQuotes): IQuoteAction => ({ type: SET_QUOTES, payload: { quotes } });
const setPolicy = (policy): IQuoteAction => ({ type: SET_POLICY, payload: { policy } });
const setSignpost = (signpost: string): IQuoteAction => ({ type: SET_SIGNPOST, payload: { signpost } });
const reset = (): IQuoteAction => ({ type: RESET });
const hasTerminalCondition = (): IQuoteAction => ({ type: HAS_TERMINAL_CONDITION });
const updateApplication = (values: any): IQuoteAction => ({ type: UPDATE_APPLICATION, payload: values });
const error = (message: any): IQuoteAction => ({ type: SET_ERROR_MESSAGE, payload: { message } });
const setActivities = (activities) => ({ type: RETRIEVE_ACTIVITIES, payload: { activities } });
const setAutoRenewalStatus = (autoRenewalStatus: string) => ({
  type: SET_AUTO_RENEWAL_STATUS,
  payload: { autoRenewalStatus },
});

const setAutoRenewalStatusReason = (autoRenewalStatusReason: string) => ({
  type: SET_AUTO_RENEWAL_STATUS_REASON,
  payload: { autoRenewalStatusReason },
});

const setCampaignCode = (campaignCode: string): IQuoteAction => ({
  type: SET_CAMPAIGN_CODE,
  payload: { campaignCode },
});

// @ts-ignore
const addStepToWizard = (step: string, formOnly = true): IQuoteAction => (dispatch, getState) => {
  const state: IStore = getState();
  const currentSteps = state.quote.application.steps;

  if (currentSteps.indexOf(step) > -1) {
    return null;
  }

  const steps = [
    ...currentSteps,
    step,
  ];

  dispatch(change('quote', 'steps', steps));

  if (! formOnly) {
    dispatch({ type: SET_STEPS, payload: { steps } });
  }
};

const setIsCalculating = (isCalculating: boolean): IQuoteAction =>
  ({ type: SET_IS_CALCULATING, payload: { isCalculating } });

// @ts-ignore
const setIsSignposting = (isSignposting: boolean): IQuoteAction =>
    ({ type: SET_IS_SIGNPOSTING, payload: { isSignposting } });

const loadDestinations = () => (dispatch) => {
  return api.listDestinations()
    .then((destinations) => {
      dispatch(setDestinations(destinations));

      return destinations;
    });
};

const purchase = (application) => (dispatch) => {
  return api.issuePolicyApplication(application)
    .then((data) => {
      dispatch(setPolicy(data));
      return data;
    });
};

const complete = (data: ICompleteData) => ({
  type: COMPLETE,
  payload: {
    ...data,
  },
});

export const getInitValues = (product: IProduct, quoteState: IQuoteState, brandingState: IBrandingState) => {
  const tripType = Object.keys(product.metadata.trip_type)[0];
  const groupType = "individual"

  return {
    ...cloneDeep(initialState.application),
    tripType,
    groupType,
  };
};



const initFromProduct = (product: IProduct, quoteState: IQuoteState, brandingState: IBrandingState) => {
  const data = getInitValues(product, quoteState, brandingState);
  return {
    type: INIT,
    payload: {
      ...data,
    },
  };
};

const recalculateScreening = () => (dispatch, getState) => {
  // @ts-ignore
  const application: IPolicyApplication = getFormValues('quote')(getState());

  if (application.id.length === 0) {
    // No point in attempting to recalculate if there is no policy application id
    return;
  }

  // Add a return type here if the screening session is healix 🚑

  application.travellers.forEach((traveller, key) => {
    if (! traveller.screeningSessionId) {
      return;
    }

    dispatch(recalculateScore(
      traveller.screeningSessionId,
      application.region,
      application.destinations,
      (screening, screeningId) => {
        dispatch(change('quote', `travellers[${key}].screeningSessionId`, screeningId));
        dispatch(change('quote', `travellers[${key}].screening`, screening));
      },
    ));
  });
};

const pollPolicyDocuments = (documentsPollToken) => () => {
  return api.documentsPoll(documentsPollToken);
};

const completeDocuments = (data: ICompleteData) => ({
  type: COMPLETE_DOCUMENTS,
  payload: {...data.documents},
});

const referralQuote = (id, referrals) => () => {
  return api.referralQuote(id, referrals);
};

const aggInvalidQuote = (value, redirectLinks) => (dispatch) => {
  forEach(redirectLinks, (item, key) => {
    if (value === key) {
      dispatch({ type: AGG_ERROR, payload: item });
    }
  });
};

const retrieveActivities = () => (dispatch) => {
  const promise = api.getActivities();

  return promise
      .then((activities) => {
        dispatch(setActivities(activities));
      });
};

const updateAutoRenewalStatus = (
    policyId: string,
    autoRenewalStatus: string,
    autoRenewalStatusReason: string) => (dispatch) => {
  api.updateAutoRenewalStatus(policyId, autoRenewalStatus, autoRenewalStatusReason)
      .then(() => {
      dispatch(setAutoRenewalStatus(autoRenewalStatus));
  });
};

const setSteps = (steps) => ({ type: SET_QUOTE_STEPS, payload: steps });
const clearAdditionalCoverOptions = () => ({ type: CLEAR_ADDITIONAL_COVER_OPTIONS });

export const actions: IQuoteActions = {
  submitForm,
  saveQuote,
  retrieveQuote,
  initFromProduct,
  loadDestinations,
  calculate,
  purchase,
  complete,
  reset,
  hasTerminalCondition,
  addStepToWizard,
  recalculateScreening,
  setPassword,
  clearErrors,
  setApplication,
  setQuotes,
  setSignpost,
  setCustomer,
  updateApplication,
  error,
  checkVoucherCode,
  dispatchVoucherCode,
  setBrokerId,
  setCampaignCode,
  pollPolicyDocuments,
  completeDocuments,
  referralQuote,
  aggInvalidQuote,
  setSteps,
  clearAdditionalCoverOptions,
  retrieveActivities,
  updateAutoRenewalStatus,
  setAutoRenewalStatusReason,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/quote/reducer.ts